// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__nIKfG","disabled":"FileBtn_disabled__1TS9i","warn":"FileBtn_warn__2Q2WC","fade":"FileBtn_fade__8y-vu"};